import { createFileRoute } from "@tanstack/react-router";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";
import { z } from "zod";
import ProductsTable from "@/components/products/products-table";

const productsSearchSchema = z.object({
  page: z.number().optional().default(1),
  search: z.string().optional(),
  category: z.string().optional(),
  status: z.string().optional(),
});

export const Route = createFileRoute("/_authenticated/products/_layout/")({
  validateSearch: productsSearchSchema,
  component: ProductsPage,
});

function ProductsPage() {
  const searchParams = Route.useSearch();

  return (
<RouteGuardPermissions
      permissions={[{ module: "products", actions: ["read"] }]}>
      
    <div className="space-y-4">
      <ProductsTable
        currentPage={searchParams.page}
        basePath="/products"
        searchParams={searchParams}
      />
    </div>
  
    </RouteGuardPermissions>
  );
}
